import loadable, { LoadableComponent } from '@loadable/component';
import dynamic from 'next/dynamic';

import { BonusPointProps } from '@zooplus/bonus-points-web-components';

const getBonusPoints = (
    isNextJS: boolean,
):
    | React.ComponentType<BonusPointProps>
    | LoadableComponent<BonusPointProps> => {
    if (isNextJS) {
        return dynamic(
            async () => {
                const pkg = await import(
                    '@zooplus/bonus-points-web-components'
                );
                return pkg.AccountNavigationBox;
            },
            {
                ssr: false,
            },
        );
    }
    return loadable(async () => {
        const pkg = await import('@zooplus/bonus-points-web-components');
        return pkg.AccountNavigationBox;
    });
};

export default getBonusPoints;
